<template>
    <span>
        <div class="row" v-for="cluster in clusteredBlocks">
            <draggable
                :list="cluster"
                class="list-group"
                group="cluster"
                ghost-class="ghost"
                :move="checkMove"
                handle=".move-handle"
                @end="repositionBlocks"
            >
                <block
                    v-for="block in cluster"
                    :key="block.position"
                    :is="getBlockType(block.type)"
                    :id="block.id"
                    :read-only="readOnly"
                ></block>
            </draggable>
        </div>

        <block-options
            v-if="!readOnly"
            :width="object.width"
            :title="$t('add_new_block') + ':'"
            @set-width="addBlock"
        ></block-options>
    </span>
</template>

<script>
    import draggable from "vuedraggable";
    import {mapState} from 'vuex';

    export default {
        components: {
            draggable
        },
        props: {
            object: Object,
            readOnly: Boolean,
        },
        data: function () {
            return {
                clusteredBlocks: [],
                swap: {
                    new: null,
                    old: null,
                    after: null,
                }
            }
        },
        methods: {
            checkMove: function(event) {
                this.swap.old = event.relatedContext.element;
                this.swap.new = event.draggedContext.element;
                this.swap.after = event.willInsertAfter + 0; // cast to int
            },
            repositionBlocks: function (event) {
                this.$store.dispatch('repositionBlock', this.swap)
                    .then(() => {this.swap = {}})
            },
            getBlockType(type) {
                return type + '-block';
            },
            addBlock: function (width) {
                var options = {
                    type: 'default',
                    width: width,
                    position: this.getNextBlockPosition(),
                    page_id: this.object.id,
                    isNewRecord: true,
                };

                if (width === 0) {
                    options.type = 'separator';
                }

                this.$store.dispatch('addBlock', options);
            },
            getNextBlockPosition: function () {
                if (!this.blocks.length) {
                    return 1;
                }

                return Math.max.apply(null, this.blocks.map(i => i.position)) + 1;
            },
            setClusteredBlocks: function () {
                var result = [];
                var cluster = [];

                this.blocks.forEach(block => {
                    var width = cluster.reduce((accumulator, i) => i.width + accumulator, 0);

                    if (block.type == 'default') {
                        if (block.width + width <= 12) {
                            cluster.push(block);
                        } else {
                            result.push(cluster);
                            cluster = [block];
                        }
                    } else if (block.type == 'separator') {
                        result.push(cluster);
                        result.push([block])
                        cluster = [];
                    }
                });

                if (cluster.length > 0) {
                    result.push(cluster);
                }

                this.clusteredBlocks = result;
            },
            // deleteBlock: function (block) {
            //     this.blocks.splice(this.blocks.indexOf(block), 1);
            // },
        },
        watch: {
            blocks: function (newValue, oldValue) {
                this.setClusteredBlocks();
            }
        },
        computed: {
            ...mapState({
                blocks: state => state.blocks,
            }),
        },
        created: function () {
            this.$store.commit('SET_BLOCKS', this.object.blocks);
            this.$store.commit('SORT_BLOCKS');
            this.setClusteredBlocks();
        },
        // mounted: function () {
        //     this.isMounted = true;
        // }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/DefaultPage.vue